import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.infra.project.detail');
import { OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-infra-project-detail',
template: templateSource || '',
    styles: [``],
})
export class PortalInfraProjectDetailComponent implements OnInit, OnDestroy {
    @Input() id: string = '';
    @Input() tab: string = 'info';
    @Input() data: any = null;
    @Input() role: string = 'visitor';
    @Input() hosts: any[] = [];
    @Input() ipList: any[] = [];
    @Input() isFavorite: boolean = false;
    @Input() ipUsage: any = {};
    @Input() ownerInfo: any = null;
    @Input() basePath: string = '/project';
    @Input() listPath: string = '/project';
    @Input() sourceQuery: string = '';
    @Input() updating: boolean = false;
    @Input() refresh: any;
    @Input() onChangeOwner: any = null;
    @Input() onToggleFavorite: any = null;

    @Output() save = new EventEmitter<void>();

    // Owner 변경 드롭다운 상태
    public ownerDropdownOpen: boolean = false;
    public ownerSearch: string = '';
    public userList: any[] = [];
    public userListLoaded: boolean = false;

    private clickListener: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.render();

        this.clickListener = (e: any) => {
            const target = e.target as HTMLElement;
            if (!target.closest('.owner-change-dropdown')) {
                if (this.ownerDropdownOpen) {
                    this.ownerDropdownOpen = false;
                    this.service.render();
                }
            }
        };
        document.addEventListener('click', this.clickListener);
    }

    public ngOnDestroy() {
        if (this.clickListener) {
            document.removeEventListener('click', this.clickListener);
        }
    }

    public tabClass(tab: string) {
        if (this.tab == tab)
            return 'cursor-pointer flex whitespace-nowrap border-b-2 border-indigo-500 px-1 py-4 text-[13px] font-medium text-indigo-600';
        return 'cursor-pointer flex whitespace-nowrap border-b-2 border-transparent px-1 py-4 text-[13px] font-medium text-gray-500 hover:border-gray-200 hover:text-gray-700';
    }

    public switchTab(tab: string) {
        this.service.href(`${this.basePath}/${this.id}/${tab}${this.sourceQuery}`);
    }

    public onSave() {
        this.save.emit();
    }

    public async toggleFavorite() {
        if (this.onToggleFavorite) {
            await this.onToggleFavorite();
        }
    }

    public grafanaUrl() {
        return 'https://grafana.infra.season.co.kr/d/85a562078cdf77779eaa1add43ccec1e/mixin-compute-resources-namespace-pods?orgId=1&refresh=10s&var-datasource=default&var-cluster=&var-namespace=' + this.data.id + '&theme=light&from=now-2d&var-resolution=5m&kiosk';
    }

    // Owner 변경 관련
    public async toggleOwnerDropdown(e: Event) {
        e.stopPropagation();
        e.preventDefault();
        if (!this.onChangeOwner) return;
        this.ownerDropdownOpen = !this.ownerDropdownOpen;
        this.ownerSearch = '';
        if (this.ownerDropdownOpen) {
            this.userListLoaded = false;
            await this.loadUsers();
        }
        await this.service.render();
    }

    public async loadUsers() {
        if (this.onChangeOwner && this.onChangeOwner.loadUsers) {
            try {
                this.userList = await this.onChangeOwner.loadUsers() || [];
                this.userListLoaded = true;
            } catch (e) {
                this.userList = [];
                this.userListLoaded = true;
            }
        }
    }

    public filteredUsers() {
        if (!this.ownerSearch) return this.userList;
        const q = this.ownerSearch.toLowerCase();
        return this.userList.filter((u: any) =>
            (u.name || '').toLowerCase().includes(q) || (u.email || '').toLowerCase().includes(q)
        );
    }

    public async selectOwner(user: any) {
        if (!this.onChangeOwner || !this.onChangeOwner.change) return;
        this.ownerDropdownOpen = false;
        await this.service.render();
        try {
            await this.onChangeOwner.change(user.id);
        } catch (e) {
            // error handling
        }
        await this.service.render();
    }
}

export default PortalInfraProjectDetailComponent;